$(function() {
    var galleryItems = $(".job-list");
    if (galleryItems.length != 0){
    $.get("/api/sitecore/hrmanager/GetExternalPositions", jobs => {
        if (jobs.length > 0) {
            var jobList = "";
            jobs.forEach(job => {
                var jobEl = `<tr>
								<td><a target="_blank" href="${job.AdvertisementUrl}">${job.Name}</a></td>
								<td>${job.PositionLocation}</td>
								<td>${job.ApplicationDue}</td>
							</tr>
							`;
                jobList += jobEl;
            });
            $("#external", galleryItems).append(jobList);
        } else {
            $("#external", galleryItems).hide();
        }
    });
    $.get("/api/sitecore/hrmanager/GetInternalPositions", jobs => {
        if (jobs.length > 0) {
            var jobList = "";
            jobs.forEach(job => {
                var jobEl = `<tr>
								<td><a target="_blank" href="${job.AdvertisementUrl}">${job.Name}</a></td>
								<td>${job.PositionLocation}</td>
								<td>${job.ApplicationDue}</td>
							</tr>
							`;
                jobList += jobEl;
            });
            $("#internal", galleryItems).append(jobList);
        } else {
            $("#internal", galleryItems).hide();
        }
    });

    }
});
